import { useEffect, useState } from 'react';

import services from 'services';

const useDarkMode = () => {
  const [darkModeAllowed, setDarkModeAllowed] = useState(services.appFrame.theme.isDarkModeAllowed);
  const [darkMode, setDarkMode] = useState(services.appFrame.theme.isDarkMode);
  const [selectedDarkMode, setSelectedDarkMode] = useState(services.appFrame.theme.getDarkModeSelection);

  useEffect(() => {
    const unsubscribeFromDarkModeChange = services.appFrame.theme.onDarkModeChange((newDarkMode) => {
      setDarkMode(newDarkMode);
    });

    const unsubscribeFromDarkModeAllowedChange = services.appFrame.theme.onDarkModeAllowedChange(
      (newDarkModeAllowed) => {
        setDarkModeAllowed(newDarkModeAllowed);
      },
    );

    const unsubscribeFromDarkModeSelectionChange = services.appFrame.theme.onDarkModeSelectionChange(
      (newSelectedDarkMode) => {
        setSelectedDarkMode(newSelectedDarkMode);
      },
    );

    return () => {
      unsubscribeFromDarkModeChange();
      unsubscribeFromDarkModeAllowedChange();
      unsubscribeFromDarkModeSelectionChange();
    };
  }, []);

  return { darkMode, darkModeAllowed, selectedDarkMode };
};
export default useDarkMode;
